/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsAlphabetListItem,
    SharedserviceMelcoModelsAlphabetListItemFromJSON,
    SharedserviceMelcoModelsAlphabetListItemFromJSONTyped,
    SharedserviceMelcoModelsAlphabetListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsUpdateAlphabetCollection
 */
export interface SharedserviceMelcoModelsUpdateAlphabetCollection {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsUpdateAlphabetCollection
     */
    name?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsAlphabetListItem>}
     * @memberof SharedserviceMelcoModelsUpdateAlphabetCollection
     */
    alphabet_list?: Array<SharedserviceMelcoModelsAlphabetListItem> | null;
}

export function SharedserviceMelcoModelsUpdateAlphabetCollectionFromJSON(json: any): SharedserviceMelcoModelsUpdateAlphabetCollection {
    return SharedserviceMelcoModelsUpdateAlphabetCollectionFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsUpdateAlphabetCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsUpdateAlphabetCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'alphabet_list': !exists(json, 'alphabet_list') ? undefined : (json['alphabet_list'] === null ? null : (json['alphabet_list'] as Array<any>).map(SharedserviceMelcoModelsAlphabetListItemFromJSON)),
    };
}

export function SharedserviceMelcoModelsUpdateAlphabetCollectionToJSON(value?: SharedserviceMelcoModelsUpdateAlphabetCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'alphabet_list': value.alphabet_list === undefined ? undefined : (value.alphabet_list === null ? null : (value.alphabet_list as Array<any>).map(SharedserviceMelcoModelsAlphabetListItemToJSON)),
    };
}


